import { createContext, useContext } from "react";

export const LenisContext = createContext(null);
export const BookingContext = createContext(() => {});
export const BookingCottageContext = createContext(null);

export const useLenis = () => useContext(LenisContext);
export const useBooking = () => useContext(BookingContext);

export const scrollToId = (lenis, href) => {
    if (window.location.pathname !== "/") {
        window.location.href = "/" + href;
        return;
    }
    if (lenis) {
        lenis.scrollTo(href, { offset: -90, duration: 1.4 });
    } else {
        document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
};
